export class MaintenanceTask {
  TaskId : number;
  Subscriber:string;
  HotelId : number;
  TaskCode : string;
  TaskName : string;
  TimeLimit: number;
  Active: boolean;
  EquipmentName : string;
  SData : string;
}